import { tzAxios } from 'api/axios';
import { TicketResponse } from 'api/responseTypes';

export const getTicketInfo = async (id: string) =>
  (await tzAxios.get<TicketResponse>(`/ticket-zone/tickets/public/${id}`)).data;

export const getEventAnnouncements = async (id: number) =>
  (await tzAxios.get<any>(`/ticket-zone/event/event/${id}/announcement`)).data;
